export default "__VITE_ASSET__745a6d85__"